import Yup from 'src/yup';

export const validations = Yup.object().shape({
  email: Yup.string().trim().email('Invalid Email address').required('Required'),
});
